import { motion } from 'framer-motion';
import styled from 'styled-components';
import { variant } from 'styled-system';
import { textStyles } from '../../../../theme/config/typography';

export const StyledMultiSelectWrapper = styled.div`
  width: 100%;
  position: relative;
`;

export const StyledMultiSelectButton = styled.button.attrs({
  variant: 'caption',
})`
  width: 100%;
  background-color: ${({ theme }) => theme.colors.multiSelect.background};
  border: 1px solid ${({ theme }) => theme.colors.background.medium};
  border-radius: 0.5rem;
  outline: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.4375rem 0.875rem;
  height: 2.5rem;
  text-align: left;
  font-size: 0.875rem;
  font-weight: 500;
  letter-spacing: -0.005em;
  color: ${({ theme }) => theme.colors.text.primary};
  transition: border-color 180ms cubic-bezier(0.4, 0, 0.2, 1),
    box-shadow 180ms cubic-bezier(0.4, 0, 0.2, 1);
  ${variant({
    variants: {
      ...textStyles,
    },
  })};
  &:hover {
    border-color: ${({ theme }) => theme.colors.accent};
  }
  &:focus-visible,
  &.is-open {
    border-color: ${({ theme }) => theme.colors.accent};
    box-shadow: 0 0 0 3px ${({ theme }) => theme.colors.accent}2E;
  }
  &[disabled],
  &:disabled {
    pointer-events: none;
    opacity: 0.5;
  }
`;

export const StyledMultiSelectButtonText = styled.span`
  display: inline-block;
  width: calc(100% - 1.75rem);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const StyledMultiSelectButtonDecor = styled.span`
  display: inline-flex;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
  margin-left: 0.625rem;
  color: ${({ theme }) => theme.colors.text.secondary};
  transition: transform 180ms cubic-bezier(0.4, 0, 0.2, 1);
  svg {
    height: 1em;
    width: 1em;
    font-size: 0.875rem;
    fill: currentColor;
  }
`;

export const StyledMultiSelectContent = styled(motion.div).attrs({
  key: 'multiselect-dropdown',
  initial: { opacity: 0, y: '-8px' },
  animate: { opacity: 1, y: 0 },
  exit: { opacity: 0, y: '-8px' },
  transition: { duration: 0.18, type: 'tween' },
})`
  width: calc(100% + 8rem);
  position: absolute;
  top: calc(100% + 0.375rem);
  background-color: ${({ theme }) => theme.colors.multiSelect.background};
  border: 1px solid ${({ theme }) => theme.colors.background.medium};
  box-shadow: ${({ theme }) => theme.shadows.dropdown};
  border-radius: 0.625rem;
  padding: 0.75rem;
  max-height: 22rem;
  overflow: auto;
  z-index: ${({ theme }) => theme.zindexes.autocomplete};
`;
